<template>

    <m-edit1/>

    <m-single-lesson-1 v-bind='{...{"courseLink":null,"lessonLink":null},...{}}' :style='""' class="" ></m-single-lesson-1>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mSingleLesson1 from '@moeinmdn/miw-alpha-components/src/package/Lesson/Single/SingleLesson1';

export default {
    name: 'HomeView',
    components: {mEdit1, mSingleLesson1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
